import { ailos } from "@/banks/ailos";
import { Banco, IGerarPDF } from "./types/Boletos";
import { bradesco } from "@/banks/bradesco";
import { sicredi } from "@/banks/sicredi";
import { sicoob } from "@/banks/sicoob";
import { bancoBrasil } from "./banks/banco-brasil";
import { itau } from "./banks/itau";

export function pdf({ banco, dados }: IGerarPDF) {
  if (banco === Banco.AILOS) {
    return ailos.gerarPDF({ banco, dados });
  }

  if (banco === Banco.BRADESCO) {
    return bradesco.gerarPDF({ banco, dados });
  }

  if (banco === Banco.SICREDI) {
    return sicredi.gerarPDF({ banco, dados });
  }

  if (banco === Banco.SICOOB) {
    return sicoob.gerarPDF({ banco, dados });
  }

  if (banco === Banco.BANCO_BRASIL) {
    return bancoBrasil.gerarPDF({ banco, dados });
  }

  if (banco === Banco.ITAU) {
    return itau.gerarPDF({ banco, dados });
  }
}
